import { format } from 'date-fns'

import { useGarageStore } from '@/modules/FindGarage'
import { useDateStore } from '@/components/DateInput'
import { DisruptionsTable } from './components/DisruptionsTable'
import styles from './Disruptions.module.scss'

export const MileageClerkDisruptions = () => {
    const { garage } = useGarageStore()
    const { date } = useDateStore()

    return (
        <section className={styles.root}>
            <header className={styles.header}>
                <div className={styles.details}>
                    <h1 className={styles.title}>{garage?.name} disruptions</h1>
                    <p className={styles.date}>{format(date, 'cccc d MMMM')}</p>
                </div>
            </header>
            <div className={styles.container}>
                <DisruptionsTable />
            </div>
        </section>
    )
}
